

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule, Routes, PreloadAllModules, NoPreloading } from '@angular/router';
//import { HttpModule } from '@angular/http';
import { ModalModule, MODAL_CONFIG_DEFAULT_OVERRIDE } from 'ngx-bootstrap/modal';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AppLayoutComponent } from './_shared/_layout/app-layout/app-layout.component';
import { AppComponent } from './app.component';
import { AppFooterComponent } from './_shared/_layout/app-footer/app-footer.component';
import { AppHeaderComponent } from './_shared/_layout/app-header/app-header.component';
import { LoginComponent } from './login/login.component';
import { NoAccessComponent } from './noAccess/noAccess.component';
import { AuthenticationService } from '@services/authentication.service';
import { CommonService } from '@services/app.common.service';
import { DataPassService } from '@services/app.datapass.service';
import { AlertService } from '@services/alert.service';
import { AppHomeLayoutComponent } from './_shared/_layout/app-homeLayout/app-homelayout.component';
import { AppFooterNewComponent } from './_shared/_layout/app-footer-new/app-footer.component';
import { AppHeaderNewComponent } from './_shared/_layout/app-header-new/app-header.component';
import { TitleService } from '@services/title.service';
import { EnvServiceProvider } from './env.service.provider';
import { RoleAccessService } from '@services/role.access.service';
import { AccessGuardService } from '@services/access.gaurd.service';
import { AuthGuardService } from '@services/auth-guard.service';
import { ObjectCreaterService } from '@services/objectCreation.service';
//import { DynamicFormModule } from './_shared/_modules/dynamicForm/dynamicForm.module';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CustomTranslateLoader } from '@services/custom.loader';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SafePipe } from './safe.pipe';
import { ApplicationUpdateCheckerService } from '@services/service-worker-check-update';
import { DataStorageService } from '@services/data-storage-service';
import { NotFoundComponent } from './notFound/not-found.component';
import { DataViewService } from '@services/data-view.service';
import { ForgotPasswordComponent } from './login/forgotPassword.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ToastrNotificationComponent } from './_shared/notifications/component/toastr-notification.component';
import { NotificationService } from './_shared/notifications/toastr-notification.service';
import { AppAnonymousUserLayoutComponent } from './_shared/_layout/app-anonymous-user-layout/app-AnonymousUserLayout.component';
import { DeviceIdentificationService } from '@services/device-identification.service';
import { TokenResolver } from './_shared/resolver/token.resolver';
import { IdServer } from './_shared/_enums/idServer';
import { SsoRedirectComponent } from './ssoRedirect/ssoRedirect.component';
import { DynamicScriptLoaderService } from '@services/dynamicScriptLoaderService';
import { ForgetPasswordUserStep1Component } from './login/forgotPasswordStep1/forgotPasswordStep1.component';
import { HeaderNotificationService } from '@services/headerNotification.service';
import { SvgIconModule } from './_shared/_customComponent/Icons/_svg/app-jt-svg-icon.module';
import { CandidatesForgetPasswordStep1Component } from './candidatesForgetPasswordStep1Component/CandidatesForgetPasswordStep1.component';
import { JtHttpInterceptor } from './_shared/_interceptor/http.interceptor';
import { updateUserPasswordComponent } from './login/updateUserPassword/updateUserPassword.component';
import { UpdatePasswordUserComponent } from './updatePasswordUserComponent/updatePasswordUser.component';
import { GATagComponent } from './ga-tag/ga-tag.component';
import { SSOLoginComponent } from './ssoLogin/ssoLogin.component';
import { DatePipe } from '@angular/common';
import { ShareModule } from '@shared/share.module';
import { forcePasswordChangeComponent } from './login/forcePasswordChange/forcePasswordChange.component';
import { PasswordStrengthMeterComponent } from 'angular-password-strength-meter';
import { provideZxvbnServiceForPSM } from 'angular-password-strength-meter/zxcvbn';
import { LoginResolver } from './login/resolvers/login.resolver';
import { JTNoCacheInterceptor } from './_shared/_interceptor/no-cache.interceptor';
import { JTUserIdleModule } from './_shared/userIdle/user-idle.module';
import { ATSLoginRedirectComponent } from './atsLogin/atsLogin.component';
import { NO_ERRORS_SCHEMA } from '@angular/compiler';
import { SlimLoadingBarModule } from './_shared/_customComponent/ng2-slim-loading-bar';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { FormatService } from './_shared/_services/app-formatservice';
import { FormDateFormatter } from './_shared/FormDateFormatter';
import { TwoFactorAuthenticationService } from './_shared/_services/two-factor-authentication.service';
import { LogoutComponent } from './logout/logout.component';
import { PasswordInputModule } from './_shared/_components/password-input/password-input.module';
import { PwnedPasswordService } from './_shared/_services/pwned-password.service';
import { PwnedPasswordInstructionsModule } from './_shared/_components/pwned-password-insturctions/pwned-password.instructions.module';
import { ChangeCompromisedPasswordComponent } from './login/changeCompromisedPassword/changeCompromisedPassword.component';

//import { CandidatesForgetPasswordStep1Component } from './CandidatesForgetPasswordStep1Component/CandidatesForgetPasswordStep1.component';
//import { HashLocationStrategy, LocationStrategy } from '@angular/common';
//Define lazy-loaded routes
const appRoutes: Routes = [
  { path: '', component: LoginComponent, resolve: { tokenResponse: LoginResolver, tokenAnonymousResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous } },
  { path: 'Login', component: LoginComponent, resolve: { tokenAnonymousResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous } },
  { path: 'Logout', component: LogoutComponent, resolve: { tokenAnonymousResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous } },
  { path: 'Login1', component: LoginComponent, resolve: { tokenAnonymousResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous } },
  { path: 'ForcePasswordChange', component: forcePasswordChangeComponent },
  { path: '404', component: NotFoundComponent },
  { path: 'NoAccess', component: NoAccessComponent },
  { path: 'SSOLogin', component: SSOLoginComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.SSOLogin } },
  {
    path: 'ForgotPassword', component: ForgotPasswordComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous }
  },
  {
    path: 'ForgetPasswordUserStep1', component: ForgetPasswordUserStep1Component, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous }
  },
  {
    path: 'updateUserPassword', component: updateUserPasswordComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous }
  },
  {
    path: 'changeCompromisedPassword', component: ChangeCompromisedPasswordComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous }
  },
  {
    path: 'MsSSORedirect', component: SsoRedirectComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Sso }
  },

  {
    path: 'ProcessForgotPassword', component: CandidatesForgetPasswordStep1Component, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous }
  },
  {
    path: 'ATSLoginRedirect', component: ATSLoginRedirectComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.ATSLogin }
  },
  //{
  //  path: 'Login/ATSLogin', component: ATSLoginRedirectComponent
  //},
  {
    path: 'UpdatePasswordUser', component: UpdatePasswordUserComponent, resolve: { tokenResponse: TokenResolver }, data: { tokenType: IdServer.TokenType.Anonymous }
  },

  {
    path: '2Fa',
    //component: AppLayoutComponent,
    loadChildren: () => import('../app/login/two-factor-authentication/two-factor-authentication.module').then(m => m.TwoFactorAuthenticationModule),
  },

  {
    path: 'reset-two-factor-authentication',
    //component: AppLayoutComponent,
    loadChildren: () => import('../app/login/two-factor-authentication/reset-two-authentication/reset-two-authentication.module').then(m => m.ResetTwoFactorAuthenticationModule),
    //canActivate: [AuthGuardService],
    //canActivateChild: [AuthGuardService]
  },



  {
    path: 'Settings',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/TalentPoolTemplate',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/talent-pool-template/talent-pool-template.module').then(m => m.TalentPoolTemplateModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },


  {
    path: 'Settings/AssessmentForms',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/assessmentForms/assessmentform.module').then(m => m.AssessmentFormModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]

  },
  {
    path: 'Settings/AlertsSetup',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/alertsSetup/alertsetup.module').then(m => m.AlertSetupModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/GeneralSettings',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/generalSettings/generalSettings.module').then(m => m.GeneralSettingsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/Redeployment',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/Redeployments/redeployments.module').then(m => m.RedeploymentsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/OnBoarding',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/onboarding/onboarding.module').then(m => m.OnboardingModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'Settings/ComplianceSettings',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/compliance/complianceSettings.module').then(m => m.ComplianceSettingsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },

  {
    path: 'Settings/SystemCustomisation',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/systemCustomisation/systemCustomisation.module').then(m => m.SystemCustomisationModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/MediaLibrary',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/mediaLibrary/mediaLibrary.module').then(m => m.MediaLibraryModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/UserSetting',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/systemUsers/systemuser.module').then(m => m.SystemUserModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/Teams',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/teams/team.module').then(m => m.TeamModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/AuthorisationUsers',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/authorisationUsers/authorisationUsers.module').then(m => m.AuthorisationUsersModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/AuthorisationGroups',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/AuthorisationGroups/authorisationGroups.module').then(m => m.AuthorisationGroupsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/JobAuthorisationMasterTemplate',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/jobAuthorisationMasterTemlate/jobAuthorisationMasterTemplate.module').then(m => m.JobAuthorisationMasterTemlateModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/AuthorisationTemplates',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/authorisationTemplates/authorisationTemplates.module').then(m => m.AuthorisationTemplateModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/MultipleDocumentsUploads',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/multipleDocumentsUploads/multipleDocumentsUploads.module').then(m => m.MultipleDocumentsUploadModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/SecurityRoles',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/securityRoles/securityRoles.module').then(m => m.SecurityRolesModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  
  {
    path: 'Home',
    component: AppHomeLayoutComponent,
    loadChildren: () => import('../app/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]

  },
  {
    path: 'InterviewsBooked',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/home/interviewsBooked/interviewsBooked.module').then(m => m.InterviewsBookedModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/UserSetting',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/userSetting/userSetting.module').then(m => m.UserSettingModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/CustomFields',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/customFields/customFields.module').then(m => m.CustomFieldsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/ApplicationTemplates',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/applicationTemplates/applicationTemplate.module').then(m => m.ApplicationTemplateModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/DirectApply',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/directApplyApplicationForm/directApplyApplicationForm.module').then(m => m.DirectApplyApplicationFormModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/SystemPipeline',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/systemPipeline/systemPipeline.module').then(m => m.SystemPipelineModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/emailOptions/emailoptions.module').then(m => m.EmailOptionsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/EmailOptions',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/emailOptions/emailoptions.module').then(m => m.EmailOptionsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/LetterOptions',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/letterOptions/letteroptions.module').then(m => m.LetterOptionsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/Contracts',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/contracts/contracts.module').then(m => m.ContractsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  
  {
    path: 'Communications/ContractSection',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/contractSection/contractsection.module').then(m => m.ContractSectionModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/SmsOptions',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/smsOptions/smsoptions.module').then(m => m.SmsOptionsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/SmsInbox',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/smsInbox/smsinbox.module').then(m => m.SmsInboxModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/SmsOutbox',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/smsOutbox/smsoutbox.module').then(m => m.SmsOutboxModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/EmailInbox',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/emailInbox/emailinbox.module').then(m => m.EmailInboxModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Communications/EmailOutbox',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/communications/emailOutbox/emailoutbox.module').then(m => m.EmailOutboxModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Search',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/search/search.module').then(m => m.SearchModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/GreenRoom',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/greenRoom/greenRoom.module').then(m => m.GreenRoomModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'JobsAndTalents',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/jobsAndTalents/jobsAndTalents.module').then(m => m.JobsAndTalentsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Calendar',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/calendar/calendar.module').then(m => m.CalendarModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'HelpAndSupport',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/helpAndSupport/helpAndSupport.module').then(m => m.HelpAndSupportModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'WorkPlace',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/workPlace/workPlace.module').then(m => m.WorkPlaceModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    component: AppLayoutComponent,
    path: 'Shared',
    loadChildren: () => import('@shared/share.module').then(m => m.ShareModule),
  },

  {
    path: 'Reports',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'AnonymousUser',
    component: AppAnonymousUserLayoutComponent,
    loadChildren: () => import('../app/anonymousUser/anonymousUser.module').then(m => m.AnonymousModule),
  },
  {
    path: 'Capture',
    loadChildren: () => import('./jobsAndTalents/fdm/gradeFare/talentCandidate/create/gradeFare.AddCandidate.module').then(m => m.GradeFareAddCandidateModule),
  },
  {
    path: 'Settings/Emails',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/EmailInbox/nylasEmails.module').then(m => m.NylasEmailsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/Calendar',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/EmailCalendar/nylasCalendar.module').then(m => m.NylasCalendarModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Settings/BrandBuilderSetup',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/settings/brandBuilderSetup/brandBuilderSetup.module').then(m => m.BrandBuilderSetupModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'Notifications',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/notifications/enhancedNotifications/enhancedNotifications.module').then(m => m.EnhancedNotificationsModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
  },
  {
    path: 'MsTeamLogInProcessing',
    loadChildren: () => import('../app/msTeamLogInProcessing/ms-team.module').then(m => m.MsTeamModule),
  },
  {
    component: AppLayoutComponent,
     path: 'integration-hub',
     loadChildren: () => import('../app/workPlace/esr-integration-hub/esr-integration-hub.module').then(m => m.EsrIntegrationHubModule),
  },
  {
    component: AppLayoutComponent,
    path: 'Candidate/CandidateFieldsRecovery',
    loadChildren: () => import('../app/jobsAndTalents/candidateFieldsRecovery/candidateFieldsRecovery.module').then(m => m.CandidateFieldsRecoveryModule),
  },


  {
    path: 'ReportBuilder',
    component: AppLayoutComponent,
    loadChildren: () => import('../app/reportBuilder/reportBuilder.module').then(m => m.ReportBuilderModule),
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService]
    },
    {
        path: 'Dashboard',
        component: AppLayoutComponent,
        loadChildren: () => import('../app/Dashboard/dashboard.module').then(m => m.DashBoardModule),
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService]
    },
    {
        path: 'ReportBuilder/public-report-library',
        component: AppLayoutComponent,
        loadChildren: () => import('../app/reportBuilder/publicReportLibrary/publicReportLibrary.module').then(m => m.PublicReportLibraryModule),
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService]
    },


  { path: '**', redirectTo: '/404' }


]


@NgModule({ declarations: [
        AppComponent,
        AppLayoutComponent,
        AppHeaderComponent,
        AppFooterComponent,
        LoginComponent,
        LogoutComponent,
        ToastrNotificationComponent,
        NoAccessComponent,
        AppHomeLayoutComponent,
        AppFooterNewComponent,
        AppHeaderNewComponent,
        SafePipe,
        ForgotPasswordComponent,
        NotFoundComponent,
        NotificationsComponent,
        AppAnonymousUserLayoutComponent,
        SsoRedirectComponent,
        SSOLoginComponent,
        ForgetPasswordUserStep1Component,
        CandidatesForgetPasswordStep1Component,
        updateUserPasswordComponent,
        UpdatePasswordUserComponent,
        forcePasswordChangeComponent,
        GATagComponent,
        ATSLoginRedirectComponent,
        ChangeCompromisedPasswordComponent
    ],
    exports: [RouterModule],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    bootstrap: [AppComponent], imports: [
        //DynamicFormModule,
        BrowserModule,
        BrowserAnimationsModule,
        SvgIconModule,
        PasswordStrengthMeterComponent,
        PasswordInputModule,
        ToastrModule.forRoot({
            timeOut: 5000000,
            positionClass: 'toast-center-custom',
            preventDuplicates: true,
            tapToDismiss: true,
            closeButton: true,
            progressBar: true,
            onActivateTick: true,
            enableHtml: true
        }),
        ShareModule,
        PwnedPasswordInstructionsModule,
        TooltipModule.forRoot(),
        ReactiveFormsModule,
        FormsModule,
        //HttpModule,
        NgxSpinnerModule,
        ModalModule.forRoot(),
        TypeaheadModule.forRoot(),
        SlimLoadingBarModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateLoader,
                deps: [HttpClient]
            }
        }),
        RouterModule.forRoot(appRoutes, {
            preloadingStrategy: NoPreloading
        }),
        // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        ServiceWorkerModule.register('jt-service-worker.js', { enabled: true }),
        JTUserIdleModule.forRoot({ idle: 2100, timeout: 300, ping: 300 })], providers: [
        AuthenticationService,
        TwoFactorAuthenticationService,
        CommonService,
        AlertService,
        PwnedPasswordService,
        ApplicationUpdateCheckerService,
        RoleAccessService,
        AccessGuardService,
        AuthGuardService,
        EnvServiceProvider,
        TokenResolver,
        DatePipe,
        LoginResolver,
        { provide: HTTP_INTERCEPTORS, useClass: JTNoCacheInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JtHttpInterceptor, multi: true },
        {
            provide: MODAL_CONFIG_DEFAULT_OVERRIDE,
            useValue: { keyboard: false, backdrop: "static" }
        },
        { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }, { provide: NgbDateParserFormatter, deps: [FormatService], useClass: FormDateFormatter },
        provideHttpClient(withInterceptorsFromDi()),
        provideZxvbnServiceForPSM()
    ] })

export class AppModule {
}

